<template>
  <v-card>
    <v-card-title>
      <span class="title font-weight-light">รายละเอียดคำร้อง</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid grid-list-md class="py-0">
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.letterNo"
              label="เลขที่หนังสือ*"
              required
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              :items="requestTypeItems"
              v-model="form.requestType"
              label="ประเภทคำร้อง*"
              item-text="name"
              return-object
              clearable
              required
              hide-details
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.code"
              label="รหัสนักศึกษา*"
              required
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.name"
              label="ชื่อ-นามสกุล*"
              required
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="form.year"
              label="ชั้นปี*"
              required
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              v-model="form.section"
              label="กลุ่มลงทะเบียน*"
              required
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-autocomplete
              :items="courseTypeItems"
              v-model="form.courseType"
              label="หลักสูตร*"
              item-text="text"
              item-value="value"
              clearable
              required
              hide-details
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md12>
            <v-autocomplete
              :items="subjectItems"
              v-model="form.subject"
              label="วิชา*"
              item-text="label"
              return-object
              clearable
              required
              hide-details
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md12>
            <v-autocomplete
              :items="facultyItems"
              v-model="form.faculty"
              label="คณะ*"
              item-text="nameTh"
              return-object
              clearable
              required
              @input="departmentItems = form.faculty.departments"
              @change="form.department = null"
              hide-details
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md12>
            <v-autocomplete
              :items="departmentItems"
              v-model="form.department"
              label="สาขา*"
              item-text="name"
              return-object
              required
              clearable
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md12>
            <v-textarea
              outline
              v-model="form.detail"
              label="รายละเอียด"
              hide-details
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-container> 
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <slot></slot>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ['form'],
  data () {
    return {
      departmentItems: []
    }
  },
  computed: {
    ...mapGetters({
      facultyItems: 'university/facultyItems',
      courseTypeItems: 'activeCourse/courseTypeItems',
      requestTypeItems: 'requestType/requestTypeItems',
      subjectItems: 'subject/subjectItems'
    })
  },
  methods: {

  },
  watch: {
    form: {
      handler (val) {
        if(val.faculty) this.departmentItems = val.faculty.departments
      },
      deep: true
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/management/student/formBasic.vue